import React from "react";
import quality from '../../assets/images/quality.png';
import reliable from '../../assets/images/reliable.png';
import susnsability from '../../assets/images/susnsability.png';
import customer from '../../assets/images/customer.png';

const Explore = () => {
    return (
        <section className="explore-flex">
            <div className="content pdding-right-40">
                <p className="common-title m-t-0">
                    Committed to Quality, Sustainability & Trust
                </p>
                <div className="explore-m-left">
                    <p className=" explore-item">
                        <img src={quality} className="common-img-width-explore" alt="quality" />
                        <span>
                            <p className="explore-common-title">Quality Assurance</p>
                            <p className="ex-subtitle">
                                We maintain the highest standards of fresh produce quality by sourcing organic fruits and vegetables directly from trusted Indian farmers. Every product undergoes rigorous quality checks to guarantee freshness, safety, and superior taste. Our focus on farm produce quality assurance makes MandiGate a trusted name in fresh grocery delivery across India.
                            </p>

                        </span>
                    </p>

                    <p className="explore-item expl-m-t">
                        <img src={reliable} className="common-img-width-explore" alt="reliable" />
                        <span>
                            <p className="explore-common-title">Reliable Supply Chain</p>
                            <p className="ex-subtitle">
                                Our agricultural supply chain is built on efficiency, transparency, and trust.We maintain a robust logistics network to ensure fresh produce delivery to customers on time — from farms to homes.This streamlined farm-to-table process ensures quality, reliability, and freshness at every step.
                            </p>
                        </span>
                    </p>

                </div>
            </div>

            <div className="right-explore-common pdding-left-40">
                <p className="ex-sublabel m-t-0">
                    At MandiGate, we are committed to delivering farm-fresh produce online with unmatched quality, sustainability, and trust. As a leading farm-to-consumer marketplace in India, our goal is to provide healthy, organic, and responsibly sourced fruits and vegetables to every household.
                </p>
                <div className="explore-m-right">
                    <p className="explore-item">
                        <img src={susnsability} className="common-img-width-explore" alt="susnsability" />
                        <span>
                            <p className="explore-common-title">Sustainability</p>
                            <p className="ex-subtitle">
                                At MandiGate, sustainability is at the core of everything we do. We promote eco-friendly farming, sustainable sourcing, and zero-waste agricultural practices to support local farmers and protect the environment. By choosing us, customers contribute to a greener, healthier future through sustainable produce delivery in India.
                            </p>
                        </span>
                    </p>

                    <p className="explore-item expl-m-t">
                        <img src={customer} className="common-img-width-explore" alt="customer" />
                        <span>
                            <p className="explore-common-title">Customer Satisfaction</p>
                            <p className="ex-subtitle">
                                Customer satisfaction is our ultimate goal.We take pride in delivering farm-fresh fruits and vegetables with exceptional service and reliability.Our commitment to quality produce, timely delivery, and transparent practices ensures that every MandiGate customer enjoys a seamless and trustworthy online grocery experience.
                            </p>
                        </span>
                    </p>

                </div>
            </div>
        </section>
    );
};

export default Explore;
